import * as React from "react";
const BalancingBall = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 96, height: 96, x: 0, y: 0, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95.5.5H.5v95h95z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#CFCFCF", d: "M47.8 59.1c-19.9 0-36 16.1-36 36h71.9c.1-19.9-16-36-35.9-36" }),
        React.createElement("path", { fill: "#3F3F3F", d: "M89 36.6 4.8 48.4l2.3 16 84.2-11.8z" }),
        React.createElement("path", { fill: "#ED0000", d: "M54.3 41.2c11.1 0 20.1-9 20.1-20.1S65.4 1 54.3 1s-20.1 9-20.1 20.1 8.999 20.1 20.1 20.1" }))));
export default BalancingBall;
//# sourceMappingURL=BalancingBall.js.map